export async function submitContactForm(form: {
  name: string;
  phone: string;
  email: string;
  orderno: string;
  body: string;
}): Promise<boolean> {
  const params = new URLSearchParams(form);
  params.append('tripwire', 'spam-bot-tripwire');
  const urlParams = '?' + params.toString();
  console.log(`/of2/public_services/contact_email${urlParams}`);
  
  try {
    const response = await fetch(`/of2/public_services/contact_email${urlParams}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data['status'] === 'ok') {
        console.log('backend responsed success', data);
        return true;
      } else {
        console.error('backend responsed error:', data);
        return false;
      }
    } else {
      console.log(response);
      
      throw new Error('server responsed error');
    }
  } catch (error) {
    console.error('Error making the request:');
    console.error(error);
    return false;
  }
}
